import { useTranslations } from "@zapier/i18n";
import { Text } from "@zapier/design-system";

interface Props {
  page: number;
  totalCount: number;
  pageSize: number;
}

export function PaginationCount({ page, totalCount, pageSize }: Props) {
  const t = useTranslations("pagination-count");

  const pageStart = totalCount ? (page - 1) * pageSize + 1 : 0;
  const pageEnd = Math.min(page * pageSize, totalCount);

  return (
    <Text tag="p" type="Body1">
      {t.rich("range-display", {
        pageStart,
        pageEnd,
        totalCount: totalCount || 0,
        strong: (chunks) => <strong>{chunks}</strong>,
      })}
    </Text>
  );
}
